/* iter561 + iter1015 — Consolidated Dashboard disclaimer.
 *
 * Единен блок "Информация за справка" за Dashboard, който обединява
 * всички разпръснати досега disclaimer/regulatory/intended-use текстове
 * (RegulatoryFooter, AppFooter compliance row, AppFooter bottom strip,
 *  AppFooter tiny universal disclaimer, DisclaimerFooter) в един ясен,
 *  четлив блок.
 *
 * Използва се на Dashboard-а. Върху AppFooter се подава hideCompliance
 * за да не се дублират същите изречения.
 */
import React from "react";
import { Info, ShieldCheck } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";

export default function RegulatoryFooter() {
  const { isDark } = useTheme();

  const wrapCls = isDark
    ? "bg-[hsl(222,47%,9%)] border-[hsl(223,47%,18%)] text-gray-300"
    : "bg-stone-50 border-stone-200 text-stone-600";
  const titleCls = isDark ? "text-white" : "text-stone-900";
  const subtleCls = isDark ? "text-gray-500" : "text-stone-500";
  const iconCls = isDark ? "text-sky-400" : "text-sky-600";

  return (
    <div
      data-testid="regulatory-disclaimer-footer"
      className={`mt-12 mb-6 mx-auto max-w-5xl px-4 py-4 rounded-xl border text-xs leading-relaxed ${wrapCls}`}
    >
      <div className="flex items-start gap-2.5">
        <Info className={`w-4 h-4 mt-0.5 shrink-0 ${iconCls}`} />
        <div className="space-y-2">
          <p className={`font-semibold ${titleCls}`}>Информация за справка</p>

          <p>
            Платформата представя образователни и сравнителни данни. Не
            замества медицинско мнение. При диабет, инсулинова терапия или
            лекарствено лечение не променяй режима без консултация с
            ендокринолог. NIS е експлоративна методология за сравнителен
            анализ на ястия — не е клинично валидирано за диагностика.
          </p>

          <p>
            <span className="font-semibold">Nutramilo</span> е AI платформа
            за персонализирано здраве и превенция. Не поставя диагнози и не
            замества медицинска консултация.
          </p>

          <p>
            <span className="font-semibold">Предназначение:</span>{" "}
            Платформата предоставя образователни анализи, оценки и
            препоръки, базирани на хранене, начин на живот и научнообосновани
            модели. Nutramilo не е медицинско изделие и не предписва
            лечение. AI генерира обяснения и персонализирани насоки, които
            не заместват консултацията с лекар или друг квалифициран здравен
            специалист.
          </p>

          <p
            data-testid="regulatory-disclaimer-notdevice"
            className={`inline-flex items-center gap-1.5 text-[11px] font-semibold ${iconCls}`}
          >
            <ShieldCheck className="w-3.5 h-3.5" />
            Wellness и образователна платформа — НЕ е медицинско изделие
          </p>

          <p className={`text-[10px] pt-2 border-t ${subtleCls} ${isDark ? "border-[hsl(223,47%,18%)]" : "border-stone-200"}`}>
            <span className="font-medium">Disclaimer:</span> Тази платформа
            предоставя само информационни анализи и не замества професионален
            медицински съвет, диагноза или лечение.
          </p>

          <p className={`text-[10px] ${subtleCls}`}>
            © {new Date().getFullYear()} Nutramilo · International Sci Ink
            Press Ltd.
          </p>
        </div>
      </div>
    </div>
  );
}
